import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const EmployeeFormModal = ({ isOpen, onClose, employee, onSave }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    rol: 'employee',
    activo: true
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (employee) {
      setFormData({
        nombre: employee?.nombre || '',
        rol: employee?.rol || 'employee',
        activo: employee?.activo !== undefined ? employee?.activo : true
      });
    } else {
      setFormData({
        nombre: '',
        rol: 'employee',
        activo: true
      });
    }
    setErrors({});
  }, [employee, isOpen]);

  const roleOptions = [
    { value: 'admin', label: 'Administrador' },
    { value: 'employee', label: 'Empleado' },
    { value: 'supervisor', label: 'Supervisor' }
  ];

  const statusOptions = [
    { value: true, label: 'Activo' },
    { value: false, label: 'Inactivo' }
  ];

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.nombre?.trim()) {
      newErrors.nombre = 'El nombre es obligatorio';
    }

    if (!formData?.rol) {
      newErrors.rol = 'El rol es obligatorio';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (validateForm()) {
      setLoading(true);
      try {
        await onSave(formData);
      } catch (err) {
        console.error('Error saving employee:', err);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors?.[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-1300 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-2xl bg-card rounded-lg shadow-xl border border-border max-h-[90vh] overflow-hidden flex flex-col animate-scale-in">
        <div className="p-4 md:p-6 border-b border-border flex items-center justify-between">
          <h3 className="text-xl font-heading font-semibold text-foreground">
            {employee ? 'Editar Empleado' : 'Nuevo Empleado'}
          </h3>
          <button
            onClick={onClose}
            className="p-2 rounded-md hover:bg-muted transition-smooth active-press"
            disabled={loading}
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto scrollbar-custom p-4 md:p-6">
          <div className="space-y-4">
            <Input
              label="Nombre Completo"
              type="text"
              placeholder="Ej: Juan García López"
              value={formData?.nombre}
              onChange={(e) => handleChange('nombre', e?.target?.value)}
              error={errors?.nombre}
              required
              disabled={loading}
            />

            <Select
              label="Rol"
              options={roleOptions}
              value={formData?.rol}
              onChange={(value) => handleChange('rol', value)}
              error={errors?.rol}
              required
              disabled={loading}
            />

            <Select
              label="Estado"
              options={statusOptions}
              value={formData?.activo}
              onChange={(value) => handleChange('activo', value)}
              disabled={loading}
            />
          </div>
        </form>

        <div className="p-4 md:p-6 border-t border-border flex flex-col sm:flex-row gap-3">
          <Button
            type="button"
            variant="outline"
            fullWidth
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="default"
            fullWidth
            iconName="Save"
            iconPosition="left"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Guardando...' : (employee ? 'Guardar Cambios' : 'Crear Empleado')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeFormModal;